const scrollers = document.querySelectorAll(".scroller");

// If a user hasn't opted in for recuded motion, then we add the animation
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  addAnimation();
}

function addAnimation() {
  scrollers.forEach((scroller) => {
    // add data-animated="true" to every `.scroller` on the page
    scroller.setAttribute("data-animated", true);

    // Make an array from the elements within `.scroller-inner`
    const scrollerInner = scroller.querySelector(".scroller__inner");
    const scrollerContent = Array.from(scrollerInner.children);

    // For each item in the array, clone it
    // add aria-hidden to it
    // add it into the `.scroller-inner`
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  function hideOneTimeOption() {
    const oneTimeOption = document.querySelector(
      ".appstle_subscription_wrapper_option:not(.appstle_include_dropdown)"
    );
    if (!oneTimeOption) return;

    // Try to read the selected variant name
    let selectedVariant = "";

    // Case 1: Dropdown variant selector
    const variantSelect = document.querySelector("select[name='id']");
    if (variantSelect) {
      selectedVariant = variantSelect.options[variantSelect.selectedIndex].text;
    }

    // Case 2: Radio / swatch selectors
    const activeRadio = document.querySelector(
      ".product-form__input input[type='radio']:checked"
    );
    if (activeRadio) {
      selectedVariant = activeRadio.value;
    }

    // Hide or show based on variant name
    if (selectedVariant.includes("60 Servings") || selectedVariant.includes("90 Servings")) {
      oneTimeOption.style.setProperty("display", "none", "important");
    } else {
      oneTimeOption.style.setProperty("display", "", "important");
    }
  }

  // Run once at load
  hideOneTimeOption();

  // Re-run whenever variant changes (dropdown or radio buttons)
  document.body.addEventListener("change", function (e) {
    if (e.target.matches("select[name='id'], .product-form__input input[type='radio']")) {
      hideOneTimeOption();
    }
  });

  // Watch for Appstle re-render and re-apply
  const observer = new MutationObserver(hideOneTimeOption);
  observer.observe(document.body, { childList: true, subtree: true });
});
